import type { Granularity, TimeRange } from "@/lib/time-range";

export interface RangePreset {
  id: string;
  label: string;
  granularity: Granularity;
  durationMs: number;
}

const MS_PER_MINUTE = 60_000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

export const RANGE_PRESETS: readonly RangePreset[] = [
  { id: "1h", label: "Last 1h", granularity: "1m", durationMs: 1 * MS_PER_HOUR },
  { id: "6h", label: "Last 6h", granularity: "5m", durationMs: 6 * MS_PER_HOUR },
  { id: "24h", label: "Last 24h", granularity: "1h", durationMs: 24 * MS_PER_HOUR },
  { id: "7d", label: "Last 7d", granularity: "1h", durationMs: 7 * MS_PER_DAY },
  { id: "30d", label: "Last 30d", granularity: "6h", durationMs: 30 * MS_PER_DAY },
] as const;

export const DEFAULT_PRESET_ID = "24h";

export function presetToRange(preset: RangePreset, now: Date = new Date()): TimeRange {
  const to = now.toISOString();
  const from = new Date(now.getTime() - preset.durationMs).toISOString();
  return { from, to, granularity: preset.granularity };
}

export function findPreset(id: string): RangePreset | undefined {
  return RANGE_PRESETS.find((p) => p.id === id);
}
